import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectCrossClientClients, selectCrossClientFilteredResults } from '../../../store/crossClient/crossClientResults'
import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { useExportCrossClientResults } from '../Results/hooks'
import { ActionsDropdownItem, ActionsToggle, CrossClientActionsDropdown } from './CrossClientActionsDropdown'
import { useCrmActions } from './useCrmActions'

export const CrossClientResultsActions: React.FC = () => {
  const results = useAppSelector(selectCrossClientFilteredResults)
  const clients = useAppSelector(selectCrossClientClients)
  const { disabled: exportDisabled, exportCSV } = useExportCrossClientResults(results)

  const count = results.length
  const crmActions = useCrmActions(results)

  const singleClient = count === 1 ? clients[results[0].clientId] : undefined
  const singleClientName = singleClient ? getUserDisplayName(singleClient) : undefined

  return (
    <CrossClientActionsDropdown
      count={count}
      singleClientName={singleClientName}
      crmActions={crmActions}
      toggle={
        <ActionsToggle variant='primary' className='button-medium rounded-3' disabled={exportDisabled}>
          Actions
          <i className='bi bi-chevron-expand ms-1' />
        </ActionsToggle>
      }
    >
      <ActionsDropdownItem icon='bi-file-earmark-spreadsheet' label='Export as CSV' onClick={exportCSV} disabled={exportDisabled} />
    </CrossClientActionsDropdown>
  )
}
